<template>
  <BreadCrumb PageTitle="Modifier Nouveau Client" />
  <NewCustomerEdit :userId="userId"  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import NewCustomerEdit from "../../components/Customers/NewCustomerEdit.vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "NewCustomerEditPage",
  components: {
    BreadCrumb,
    NewCustomerEdit,
  },

  setup: () => {
    const route = useRoute();
    let userId = route.params.id;  // <-- get the id
    if (Array.isArray(userId)) {
      userId = userId[0] ?? "";
    }


    return { userId };
}
});
</script>